// Database Configuration
// .env dosyasında bu değerleri tanımlayın:

// MSSQL Configuration
export const mssqlConfig = {
  server: 'localhost\\SQLEXPRESS',  // Named Instance
  database: 'onur_beton',
  user: 'yagiz',                    // SQL Authentication kullanıcısı
  password: 'Yagizyagmur1',
  options: {
    encrypt: false,                 // Local SQL Server için
    trustServerCertificate: true
  }
};


// Firebase Configuration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAQt18-S6TLHYROLrCvZ4K-SpaKvRoJAXc",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "onur-beton.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "onur-beton",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "onur-beton.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "730357968213",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:730357968213:web:6a3d163b619a78f1e493dc",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-JZL6BJE8LE"
};

// Environment Variables Örneği (.env dosyasına ekleyin):
/*
# MSSQL Database Configuration (SQL Server Express için - Windows Authentication)
DB_SERVER=localhost\SQLEXPRESS
DB_NAME=onur_beton
# Windows Authentication kullanıldığı için DB_USER ve DB_PASSWORD gerekmez

# Firebase Configuration
REACT_APP_FIREBASE_API_KEY=AIzaSyAQt18-S6TLHYROLrCvZ4K-SpaKvRoJAXc
REACT_APP_FIREBASE_AUTH_DOMAIN=onur-beton.firebaseapp.com
REACT_APP_FIREBASE_PROJECT_ID=onur-beton
REACT_APP_FIREBASE_STORAGE_BUCKET=onur-beton.firebasestorage.app
REACT_APP_FIREBASE_MESSAGING_SENDER_ID=730357968213
REACT_APP_FIREBASE_APP_ID=1:730357968213:web:6a3d163b619a78f1e493dc
REACT_APP_FIREBASE_MEASUREMENT_ID=G-JZL6BJE8LE
*/ 